<script lang="ts">
  import LoadingSpinner from "./Icons/LoadingSpinner.svelte"

  let isAffiliatePopupOpen = $state(false)
  let popupContainer: HTMLDivElement

  function toggleAffiliatePopup() {
    isAffiliatePopupOpen = !isAffiliatePopupOpen
  }

  $effect(() => {
    if (isAffiliatePopupOpen && popupContainer) {
      const existingScript = document.querySelector(
        'script[src="https://refgrow.com/js/page.js"]',
      )
      if (existingScript) {
        existingScript.remove()
      }

      const script = document.createElement("script")
      script.src = "https://refgrow.com/js/page.js"
      script.async = true
      document.body.appendChild(script)
    }
  })

  type FooterLink = {
    name: string
    href: string
    ariaLabel?: string
    isAffiliateLink?: boolean
  }

  const footerItems = {
    blocks: [
      {
        title: "Product",
        links: [
          { name: "Pricing & Plans", href: "/pricing" },
          { name: "Giveaway Directory", href: "/giveaways" },
          { name: "(Free) Random Name Picker", href: "/random-name-picker" },
          {
            name: "Instagram Comment Picker",
            href: "/instagram-comment-picker",
          },
          {
            name: "Sweepstakes Rules Generator",
            href: "/sweepstakes-rules-generator",
          },
        ] as FooterLink[],
      },
      // {
      //   title: "Company",
      //   links: [
      //     { name: "About us", href: "/about" },
      //     // { name: "Blog", href: "/blog" },
      //     // { name: "Careers", href: "#" },
      //   ],
      // },
      {
        title: "Resources",
        links: [
          { name: "Blog", href: "/blog" },
          {
            name: "130 Best Giveaway Prize Ideas",
            href: "/blog/best-giveaway-prize-ideas",
          },
          {
            name: "Affiliate Program",
            href: "#",
            isAffiliateLink: true,
          },
          { name: "Privacy Policy", href: "/privacy" },
          { name: "Terms of use", href: "/terms" },
        ] as FooterLink[],
      },
      {
        title: "Contact Us",
        links: [
          { name: "hi@promoamp.com", href: "mailto:hi@promoamp.com" },
          // { name: "support@promoamp.com", href: "mailto:support@promoamp.com" },
          // { name: "Status", href: "#" },
        ] as FooterLink[],
      },
    ],
    branding: {
      logo: {
        src: "/logo.svg",
        alt: "Promo Amp Home Page",
        width: 160,
        href: "/",
      },
      byline:
        "Grow your business with effortless giveaways. Launch, manage, and track competitions with ease with Promo Amp. 🚀",
      social: [
        {
          name: "Twitter",
          href: "https://x.com/promoamp",
          ariaLabel: "Follow us on X",
          icon: "twitter",
        },
        {
          name: "Instagram",
          href: "https://www.instagram.com/promoamp",
          ariaLabel: "Follow us on Instagram",
          icon: "instagram",
        },
        {
          name: "LinkedIn",
          href: "https://www.linkedin.com/company/promo-amp",
          ariaLabel: "Follow us on LinkedIn",
          icon: "linkedin",
        },
      ],
      copyright: `© ${new Date().getFullYear()} PromoAmp.com - All rights reserved.`,
    },
  }
</script>

<footer>
  <div class="max-w-6xl mx-auto px-4 sm:px-6">
    <!-- Top area: Blocks -->
    <div class="grid sm:grid-cols-12 gap-10 py-8 md:py-12">
      <!-- Branding block -->
      <div class="sm:col-span-12 lg:col-span-4 space-y-6">
        <div>
          <!-- Logo -->
          <a
            class="inline-flex"
            href={footerItems.branding.logo.href}
            aria-label={footerItems.branding.logo.alt}
          >
            <img
              src={footerItems.branding.logo.src}
              alt={footerItems.branding.logo.alt}
              width={footerItems.branding.logo.width}
            />
          </a>
        </div>
        <div class="text-sm text-gray-600">
          {footerItems.branding.byline}
        </div>

        <!-- Social Media Icons -->
        <div class="flex space-x-4">
          {#each footerItems.branding.social as social}
            <a
              href={social.href}
              aria-label={social.ariaLabel}
              class="text-gray-400 hover:text-gray-600 transition-colors"
              rel="external"
              target="_blank"
            >
              {#if social.icon === "twitter"}
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                  />
                </svg>
              {:else if social.icon === "instagram"}
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                  />
                </svg>
              {:else if social.icon === "linkedin"}
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                  />
                </svg>
              {/if}
            </a>
          {/each}
        </div>

        <div class="text-sm text-gray-600">
          {footerItems.branding.copyright}
        </div>
      </div>

      <!-- Dynamic blocks -->
      {#each footerItems.blocks as block}
        <div class="sm:col-span-6 md:col-span-3 lg:col-span-2 space-y-9">
          <h3 class="text-sm font-medium">{block.title}</h3>
          <ul class="text-sm space-y-3">
            {#each block.links as link}
              <li>
                <a
                  class="text-gray-600 hover:text-gray-900 transition"
                  href={link.href}
                  aria-label={link.ariaLabel || link.name}
                  rel="external"
                  onclick={link.isAffiliateLink
                    ? (e) => {
                        e.preventDefault()
                        toggleAffiliatePopup()
                      }
                    : null}
                >
                  {link.name}
                </a>
              </li>
            {/each}
          </ul>
        </div>
      {/each}
    </div>
  </div>

  <div
    class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50"
    class:hidden={!isAffiliatePopupOpen}
  >
    <div
      class="bg-white p-8 rounded-lg shadow-lg relative max-w-6xl w-full max-h-[80vh] overflow-y-auto"
      bind:this={popupContainer}
    >
      <button
        class="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
        onclick={toggleAffiliatePopup}
        aria-label="Close popup"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <div id="refgrow" data-project-id="125">
        <div class="flex justify-center items-center h-40">
          <LoadingSpinner class="!w-10 !h-10" />
        </div>
      </div>
    </div>
  </div>
</footer>
